import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TDOReferringDataDoctorModel} from '../../configuration/referral-configuration/models/referral-data.model';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PatientSearchModel} from '../../../models/patient/patient-search.model';
import {dataPatientInsurance} from '../../ar/_models/ar.models';

@Component({
  standalone: false,
    selector: 'app-referral-match-list',
    templateUrl: './referral-match-list.component.html',
    styleUrls: ['./referral-match-list.component.scss']
})
export class ReferralMatchListComponent {
    @ViewChild('referralMatchListTable') referralMatchListTable: TdoTableV2Component;
    @ViewChild('referralMatchPatientListTable') referralMatchPatientListTable: TdoTableV2Component;
    @ViewChild('referralMatchInsuranceListTable') referralMatchInsuranceListTable: TdoTableV2Component;
    searchPredicate: (data: any, filter: string) => boolean;

    isLoading: boolean = false;
    Title: string = '';
    listTDOReferralDoctor: TDOReferringDataDoctorModel[] = [];
    listMatchTDOPatients: PatientSearchModel[] = [];
    listMatchTDOInsurances: dataPatientInsurance[] = [];
    selectedTDOReferralDoctor: TDOReferringDataDoctorModel;
    selectedTDOPatient: PatientSearchModel;
    selectedTDOPatientInsurance: dataPatientInsurance;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private snackBar: MatSnackBar,
                private dialogRef: MatDialogRef<ReferralMatchListComponent>)
    {
        this.searchPredicate = (dataSearch: any, filter: string) => {
            if ((!dataSearch.model.dataContact.FirstName ? '' : dataSearch.model.dataContact.FirstName).toLowerCase().includes(filter)) {
                return true;
            } else if ((!dataSearch.model.dataContact.LastName ? '' : dataSearch.model.dataContact.LastName).toLowerCase().includes(filter)) {
              return true;
            } else if ((!dataSearch.model.primaryPhone ? '' : dataSearch.model.primaryPhone).toLowerCase().includes(filter)) {
                return true;
            } else if ((!dataSearch.model.primaryEmail ? '' : dataSearch.model.primaryEmail).toLowerCase().includes(filter)) {
                return true;
            } else {
                return false;
            }
        };

    }

    ngOnInit(): void {
        if (this.data) {
            this.Title = this.data.Title;
            if (this.data.isReferralDoctor) {
                this.listTDOReferralDoctor = this.data.listTDOReferralDoctor;
            } else if (this.data.isPatient) {
                this.listMatchTDOPatients = this.data.listMatchTDOPatients;
            } else if (this.data.isInsurance) {
                this.listMatchTDOInsurances = this.data.listMatchTDOInsurances;
            }
        }


    }


    onRowSelected(event: TdoTableSelectionEvent) {
        this.selectedTDOReferralDoctor = event.model;
    }

    onRowPatientSelected(event: TdoTableSelectionEvent) {
        this.selectedTDOPatient = event.model;
    }

    onRowPatientInsuranceSelected(event: TdoTableSelectionEvent) {
        this.selectedTDOPatientInsurance = event.model;
    }


    close() {
        this.dialogRef.close();
    }

    onOkAction() {
        if (this.data.isReferralDoctor) {
            if (this.selectedTDOReferralDoctor === null || this.selectedTDOReferralDoctor === undefined) {
                this.snackBar.open('Please select Doctor', 'Referral Provider', {
                    duration: 3000,
                    verticalPosition: 'top'
                });
                return;
            }
            this.dialogRef.close(this.selectedTDOReferralDoctor);
        } else if (this.data.isPatient) {
            if (this.selectedTDOPatient === null || this.selectedTDOPatient === undefined) {
                this.snackBar.open('Please select Patient', 'Referral Provider', {
                    duration: 3000,
                    verticalPosition: 'top'
                });
                return;
            }
            this.dialogRef.close(this.selectedTDOPatient);
        } else if (this.data.isInsurance) {
            if (this.selectedTDOPatientInsurance === null || this.selectedTDOPatientInsurance === undefined) {
                this.snackBar.open('Please select Patient Insurance', 'Referral Provider', {
                    duration: 3000,
                    verticalPosition: 'top'
                });
                return;
            }
            this.dialogRef.close(this.selectedTDOPatientInsurance);
        }
    }

}
